<template>
  <div class="department-card" :class="classObject" :style="department.type === 3 || department.type === 4 ? `background: ${department.color};` : ''" v-if="department.id">
    <div class="department-card__header">
      <p class="department-card__name" :title="department.name">{{ department.name }}</p>
    </div>
    <div class="department-card__body">
      <div class="department-card__dep-head">
          <div class="department-card__avatar-wrap" v-if="department.head">
            <router-link :to="`/user/info/${department.head.id}/personal`"
                         class="department-card__dep-head__link"
                         @click.stop>
              <div class="user-avatar department-card__avatar">
                <img v-if="department.head.avatar !== null && department.head.avatar.file_size"
                     :src="department.head.avatar.url" :alt="department.head.full_name">
                <img v-else src="/img/svg/avatar__icon.svg" :alt="department.head.profile.full_name">
              </div>
            </router-link>
            <!-- всплывашка руководителя отдела -->
            <div class="department-card__tooltip" v-if="department.head" @click.stop>
              <div class="user-tooltip">
                <div class="user-tooltip__info">
                  <p class="user-tooltip__row">
                    <span class="user-tooltip__info-item">Дата рождения:</span>
                    <span class="user-tooltip__info-val">{{ formatDate(department.head.profile.birth_at) }}</span>
                  </p>
                  <p class="user-tooltip__row">
                    <span class="user-tooltip__info-item">E-mail:</span>
                    <span class="user-tooltip__info-val">{{ department.head.email }}</span>
                  </p>
                  <p class="user-tooltip__row">
                    <span class="user-tooltip__info-item">Телефон:</span>
                    <span class="user-tooltip__info-val">{{ department.head.phone }}</span>
                  </p>
                  <p class="user-tooltip__row">
                    <span class="user-tooltip__info-item">Статус:</span>
                    <span class="user-tooltip__info-val">{{getUserStatus(department.head.status_id)}}</span>
                  </p>
                </div>
                <div class="user-tooltip__personal">
                  <div class="user-avatar user-tooltip__avatar">
                    <img v-if="department.head.avatar !== null && department.head.avatar.file_size"
                         :src="department.head.avatar.url" :alt="department.head.profile.full_name">
                    <img v-else src="/img/svg/avatar__icon.svg" :alt="department.head.profile.full_name">
                  </div>
                  <p class="user-tooltip__name">
                    {{ department.head.profile.full_name }}
                  </p>
                  <p class="user-tooltip__position">{{getUserPosition(department.head.position_id)}}</p>
                </div>
              </div>
            </div>
            <!-- /всплывашка руководителя отдела -->
          </div>
          <router-link :to="`/user/info/${department.head.id}/personal`"
                       class="department-card__user-name"
                       v-if="department.head"
                       @click.stop>
            {{ department.head.profile.full_name }}
          </router-link>
        <p class="department-card__user-name" v-else>
          {{ (department.type === 0 || department.type === 1 || department.type === 2) ? 'Не назначен' : 'Руководитель не назначен' }}
        </p>
      </div>
      <div class="ckp" :class="department.type === 0 || department.type === 1 || department.type === 2 ? 'ckp_director' : ''" @click.stop="showDetailModal">
        <span v-if="department.ckp">ЦКП: {{ department.ckp.length > 65 ? `${department.ckp.slice(0, 65)}...` : department.ckp }}</span>
        <span v-else>ЦКП: Не определен</span>
      </div>
      <div class="department-card__dep-staff" v-if="department.type !== 0 && department.type !== 1 && department.type !== 2">
        <div class="department-card__subtitle">
          Сотрудники
          <span class="department-card__amount" @click.stop="toggleStaffList">
            <span class="department-card__amount__icon">
              <svg width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#staff-amount_clip0)">
                <circle cx="7.7077" cy="10.2472" r="3.59051" stroke="currentColor" stroke-width="1.5"/>
                <mask id="path-3-inside-1" fill="white">
                <path d="M14.4161 20.5068C14.4161 19.6258 14.2426 18.7536 13.9055 17.9397C13.5684 17.1258 13.0743 16.3864 12.4514 15.7635C11.8285 15.1405 11.089 14.6464 10.2751 14.3093C9.46126 13.9722 8.58897 13.7987 7.70806 13.7987C6.82714 13.7987 5.95485 13.9722 5.141 14.3093C4.32714 14.6464 3.58765 15.1406 2.96474 15.7635C2.34184 16.3864 1.84773 17.1258 1.51062 17.9397C1.17351 18.7536 1 19.6259 1 20.5068L2.45256 20.5068C2.45256 19.8166 2.58849 19.1332 2.85261 18.4956C3.11672 17.8579 3.50384 17.2786 3.99186 16.7906C4.47988 16.3025 5.05924 15.9154 5.69686 15.6513C6.33449 15.3872 7.0179 15.2513 7.70806 15.2513C8.39822 15.2513 9.08162 15.3872 9.71925 15.6513C10.3569 15.9154 10.9362 16.3025 11.4243 16.7906C11.9123 17.2786 12.2994 17.8579 12.5635 18.4956C12.8276 19.1332 12.9636 19.8166 12.9636 20.5068H14.4161Z"/>
                </mask>
                <path d="M14.4161 20.5068C14.4161 19.6258 14.2426 18.7536 13.9055 17.9397C13.5684 17.1258 13.0743 16.3864 12.4514 15.7635C11.8285 15.1405 11.089 14.6464 10.2751 14.3093C9.46126 13.9722 8.58897 13.7987 7.70806 13.7987C6.82714 13.7987 5.95485 13.9722 5.141 14.3093C4.32714 14.6464 3.58765 15.1406 2.96474 15.7635C2.34184 16.3864 1.84773 17.1258 1.51062 17.9397C1.17351 18.7536 1 19.6259 1 20.5068L2.45256 20.5068C2.45256 19.8166 2.58849 19.1332 2.85261 18.4956C3.11672 17.8579 3.50384 17.2786 3.99186 16.7906C4.47988 16.3025 5.05924 15.9154 5.69686 15.6513C6.33449 15.3872 7.0179 15.2513 7.70806 15.2513C8.39822 15.2513 9.08162 15.3872 9.71925 15.6513C10.3569 15.9154 10.9362 16.3025 11.4243 16.7906C11.9123 17.2786 12.2994 17.8579 12.5635 18.4956C12.8276 19.1332 12.9636 19.8166 12.9636 20.5068H14.4161Z" fill="currentColor" stroke="currentColor" stroke-width="3" mask="url(#path-3-inside-1)"/>
                <path d="M1 20.281H14.4161" stroke="currentColor" stroke-width="1.5"/>
                <circle cx="17.2917" cy="8.33074" r="3.59051" stroke="currentColor" stroke-width="1.5"/>
                <mask id="path-6-inside-2" fill="white">
                <path d="M24.0001 18.5901C24.0001 17.0693 23.4833 15.5935 22.5344 14.4049C21.5855 13.2164 20.2609 12.3855 18.7778 12.0487C17.2947 11.7118 15.7411 11.889 14.3719 12.551C13.0027 13.2131 11.8991 14.3208 11.2421 15.6925L12.6135 16.3493C13.1215 15.2886 13.975 14.432 15.0338 13.92C16.0927 13.408 17.2941 13.271 18.441 13.5315C19.5879 13.792 20.6123 14.4345 21.3461 15.3536C22.0799 16.2728 22.4795 17.414 22.4795 18.5901H24.0001Z"/>
                </mask>
                <path d="M24.0001 18.5901C24.0001 17.0693 23.4833 15.5935 22.5344 14.4049C21.5855 13.2164 20.2609 12.3855 18.7778 12.0487C17.2947 11.7118 15.7411 11.889 14.3719 12.551C13.0027 13.2131 11.8991 14.3208 11.2421 15.6925L12.6135 16.3493C13.1215 15.2886 13.975 14.432 15.0338 13.92C16.0927 13.408 17.2941 13.271 18.441 13.5315C19.5879 13.792 20.6123 14.4345 21.3461 15.3536C22.0799 16.2728 22.4795 17.414 22.4795 18.5901H24.0001Z" fill="currentColor" stroke="currentColor" stroke-width="3" mask="url(#path-6-inside-2)"/>
                <path d="M13.4585 18.3646L23.9997 18.3646" stroke="currentColor" stroke-width="1.5"/>
                </g>
                <defs>
                <clipPath id="staff-amount_clip0">
                <rect width="25" height="25" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </span>
            {{ staffCount }}
          </span>
          <!-- всплывашка со списком сотрудников -->
          <transition name="fade">
            <div v-show="isStaffListActive" class="staff-popup staff-popup_active">
              <ul v-if="department.users.length !== 0" class="staff-popup__list">
                <li v-for="(user, i) in department.users"
                    :key="i"
                    class="staff-popup__item"
                >
                  <router-link :to="`/user/info/${user.id}/personal`" class="staff-popup__link" :title="user.profile.name" @click.stop="">
                    <span class="user-avatar department-card__avatar">
                      <img v-if="user.avatar !== null && user.avatar.file_size"
                           :src="user.avatar.url" :alt="user.profile.name">
                      <img v-else src="/img/svg/avatar__icon.svg" :alt="user.profile.full_name">
                    </span>
                    <p class="staff-popup__user-name">
                      {{ user.profile.full_name }}
                    </p>
                  </router-link>
                </li>
              </ul>
              <ul v-else class="staff-popup__list">
                <li class="staff-popup__item">
                  <div class="staff-popup__link">
                    <p class="staff-popup__user-name">
                      Сотрудники отсутствуют
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </transition>
          <!-- /всплывашка со списком сотрудников -->
        </div>
        <div class="department-card__staff-list">
          <div class="department-card__staff-list__item"
               v-for="user in department.users.slice(0, 4)"
               :key="user.id">
            <router-link :to="`/user/info/${user.id}/personal`"
               class="user-avatar department-card__avatar"
               @click.stop>
              <img v-if="user.avatar !== null && user.avatar.file_size" :src="user.avatar.url"
                   :alt="user.profile.full_name">
              <img v-else src="/img/svg/avatar__icon.svg" :alt="user.profile.full_name">
            </router-link>
            <div class="department-card__staff-list__tooltip">
              <!-- всплывашка сотрудника отдела -->
              <div class="user-tooltip">
                <div class="user-tooltip__info">
                  <p class="user-tooltip__row">
                    <span class="user-tooltip__info-item">Дата рождения:</span>
                    <span class="user-tooltip__info-val">{{ formatDate(user.profile.birth_at) }}</span>
                  </p>
                  <p class="user-tooltip__row">
                    <span class="user-tooltip__info-item">E-mail:</span>
                    <span class="user-tooltip__info-val">{{ user.email }}</span>
                  </p>
                  <p class="user-tooltip__row">
                    <span class="user-tooltip__info-item">Телефон:</span>
                    <span class="user-tooltip__info-val">{{ user.phone }}</span>
                  </p>
                  <p class="user-tooltip__row">
                    <span class="user-tooltip__info-item">Статус:</span>
                    <span class="user-tooltip__info-val">{{getUserStatus(user.status_id)}}</span>
                  </p>
                </div>
                <div class="user-tooltip__personal">
                  <div class="user-avatar user-tooltip__avatar">
                    <img v-if="user.avatar !== null && user.avatar.file_size"
                         :src="user.avatar.url" :alt="user.profile.full_name">
                    <img v-else src="/img/svg/avatar__icon.svg" :alt="user.profile.full_name">
                  </div>
                  <p class="user-tooltip__name">
                    {{ user.profile.full_name }}
                  </p>
                  <p class="user-tooltip__position">{{getUserPosition(user.position_id)}}</p>
                </div>
              </div>
              <!-- /всплывашка сотрудника отдела -->
            </div>
          </div>
        </div>
      </div>
      <div class="department-card__more"
           :class="department.type !== 5 ? 'department-card__more_no-button' : ''">
        <!--при необходимости скрыть меню - вернуть условие-->
        <!--v-if="currentUser.is_superuser"-->
        <div class="department-card__menu" v-if="allowControls" @click.stop="toggleControls">
          <svg class="ellipsis-icon" viewBox="0 0 23 4" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="2" r="2" fill="currentColor"/>
            <circle cx="11" cy="2" r="2" fill="currentColor"/>
            <circle cx="21" cy="2" r="2" fill="currentColor"/>
          </svg>
        </div>
        <div class="department-card__controls" v-if="allowControls">
          <transition name="fade">
            <AppPopupControls v-show="isControlsActive"
                              :active-buttons="controlsButtons"
                              :addButton="addButtonTitle"
                              @add-to-this-item="addChildDepartment"
                              @edit-this-item="updateDepartment"
                              @remove-this-item="removeDepartment"
            />
          </transition>
        </div>
      </div>
      <div class="department-card__show-more-wrap" v-if="department.type === 5">
        <div v-if="!department.modal_parent && department.type === 5 && department.children.length >= 1"
             class="department-card__show-more department-card__show-more_active"
             @click.stop="showModal">
          секторов: {{ department.children.length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppPopupControls from '../popup/AppPopupControls'

export default {
  name: 'department-card',
  components: {
    AppPopupControls
  },
  props: {
    isControlsActive: {
      type: Boolean,
      default: false
    },
    isStaffListActive: {
      type: Boolean,
      default: false
    },
    department: {
      type: Object,
      default: () => ({})
    },
    allowControls: {
      type: Boolean,
      default: false
    },
    allowedControlItems: {
      type: Object,
      default: () => ({
        add: true, update: true, remove: false
      })
    }
  },
  computed: {
    classObject () {
      return {
        'department-card_no-bg-image': this.department.type === 3 || this.department.type === 4,
        'department-card_section': this.department.type === 5 || this.department.type === 6,
        'department-card_has-sections': this.department.type === 4 && this.department.children && this.department.children.length !== 0
      }
    },
    addButtonTitle () {
      let title = 'Создать подотдел'
      switch (this.department.type) {
        case 0:
          title = 'Создать подотдел'
          break
        case 1:
          title = 'Создать директора'
          break
        case 2:
          title = 'Создать отделение'
          break
        case 3:
          title = 'Создать отдел'
          break
        case 4:
          title = 'Создать секцию'
          break
        case 5:
          title = 'Создать сектор'
          break
        default:
          break
      }
      return title
    },
    controlsButtons () {
      const buttons = {
        add: this.allowedControlItems.add,
        edit: this.allowedControlItems.update,
        remove: this.allowedControlItems.remove
      }
      switch (this.department.type) {
        case 0:
          buttons.remove = false
          break
        case 6:
          buttons.add = false
          break
        default:
          break
      }
      return buttons
    },
    staffCount () {
      return this.department.users.length
    },
    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    toggleControls () {
      this.$emit('toggle-controls')
    },
    toggleStaffList () {
      this.$emit('toggle-staff-list')
    },
    updateDepartment () {
      this.$emit('update-department', this.department)
    },
    removeDepartment () {
      this.$emit('remove-department')
    },
    showModal () {
      this.$emit('show-department-modal', this.department)
    },
    getUserStatus (id) {
      if (id) {
        return this.$store.getters.getStatusById(id)
      }
    },
    getUserPosition (id) {
      if (id) {
        return this.$store.getters.getPositionById(id)
      }
    },
    addChildDepartment () {
      const parent = {
        id: this.department.id,
        name: this.department.name,
        type: this.department.type
      }
      this.$emit('add-child-department', parent)
    },
    formatDate (date) {
      const newDate = new Date(date)
      const formatDay = newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()
      // +1 потому что отсчет месяцев начинается с нуля и до 11
      const formatMonth = newDate.getMonth() + 1 < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1
      const year = newDate.getFullYear()
      return `${formatDay}.${formatMonth}.${year}`
    },
    showDetailModal () {
      this.$emit('show-detail-modal', this.department)
    }
  }
}
</script>

<style lang="scss" scoped>

.department-card {
  width: 285px;
  border: 1px solid $border_color;
  border-radius: 3px;
  // box-shadow: 0 4px 4px rgba(23, 63, 125, 0.25);
  background-color: $color__orange;

  &_section {
    border-top: none;
    background-color: $color_sixth;
    border-radius: 0;

    .department-card__header {
      color: $font_color_third;
      background: url('/img/svg/background_02_opacity.svg') no-repeat;
      background-size: cover;
    }
  }

  &_has-sections {
    box-shadow: 4px 0 4px -4px rgba(23, 63, 125, 0.25);
    border-bottom: none;
  }

  &_no-bg-image {
    .department-card__header {
      background-image: none;
    }
  }

  &__header {
    padding: 25px 15px;
    background-size: cover;
    display: flex;
    flex-flow: column;
    align-items: center;
    color: $color__white;
  }

  &__name {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__body {
    background-color: $color_main;
    color: $font_color_main;
    padding-top: 15px;
  }

  &__subtitle {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    color: $font_color_second;
    font-weight: bold;
    padding-bottom: 15px;
  }

  &__dep-head {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 0 15px 15px;
    border-bottom: 1px solid $border_color;
    height: 70px;

    &__link {
      display: flex;
      align-items: center;
    }
  }

  &__dep-staff {
    padding: 20px 15px 0 15px;
  }

  &__amount {
    display: flex;
    align-items: center;
    height: 100%;
    color: $color_third-03;
    font-weight: normal;
    cursor: pointer;

    &__icon {
      display: block;
      @include size(20px);
      margin-right: 2px;

      svg {
        transition: .3s;
        vertical-align: top;
      }

      &:hover {
        color: $color_second-light;
      }
    }
  }

  &__avatar-wrap {
    position: relative;

    &:hover {
      border-color: red;
      .department-card__tooltip {
        display: block;
      }
    }
  }

  &__avatar {
    margin-right: 10px;
  }

  &__staff-list {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    height: 40px;

    &__item {
      position: relative;
      &:hover {
        .department-card__staff-list__tooltip {
          display: block;
        }
      }
    }

    &__tooltip {
      display: none;
      position: absolute;
      z-index: 999;
      top: 27px;
      left: -12px;
      right: auto;
      width: 620px;
      padding-top: 20px;
      animation: fadeIn .3s ease-in;
    }
  }

  &__more {
    position: relative;
    padding-right: 15px;
    padding-left: 15px;

    &_no-button {
      margin-top: 6px;
      padding-bottom: 14px;
    }
  }

  &__menu {
    color: $color__brown;
    line-height: 0.5;
    width: 23px;
    margin-left: auto;
    cursor: pointer;
    transition: .3s;

    &:hover {
      color: $color__orange;
    }
  }

  &__controls {
    position: absolute;
    top: 15px;
    left: auto;
    right: 11px;
  }

  &__tooltip {
    display: none;
    position: absolute;
    z-index: 99;
    top: calc(100%);
    left: -14px;
    width: 620px;
    padding-top: 20px;
    animation: fadeIn .3s ease-in;
  }

  &__show-more-wrap {
    margin-top: 10px;
    background-color: $color_main;
    height: 30px;
  }

  &__show-more {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: $button_color_second;
    font-size: 14px;
    color: $font_color_alt;
    transition: .3s;
    cursor: pointer;
    margin-top: 5px;

    &:hover {
      box-shadow: inset 0 2px 2px rgba(44, 4, 48, 0.54);
    }

  }
}

.ckp {
  font-size: 14px;
  padding: 15px;
  border-bottom: 1px solid $border_color;
  height: 84px;
  overflow: hidden;
  cursor: pointer;
  transition: .3s;

  &_director {
    border-bottom: none;
  }

  &:hover {
    background: $color__orange;
    color: $color__white;
  }
}

.user-tooltip {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  background-color: $color_main;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  animation: fadeIn .3s ease-in;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: -6px;
    left: 25px;
    margin: 0 auto;
    width: 10px;
    height: 10px;
    background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
    border: 1px solid $border_color;
    border-bottom: none;
    border-right: none;
    transform: rotate(45deg);
  }

  &__info {
    flex: 1;
    padding: 25px;
    border-right: 1px solid $border_color;
  }

  &__personal {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 25px;
    width: 50%;
    max-width: 250px;
  }

  &__row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__info-item {
    color: $font_color_second;
    margin-right: 10px;
  }

  &__name {
    font-weight: bold;
    color: $color__brown;
    text-align: center;
    margin-bottom: 20px;
  }

  &__position {
    text-align: center;
    color: $font_color_second;
    font-size: 14px;
  }

  &__avatar {
    @include size(78px);
    margin-bottom: 20px;
  }
}

.staff-popup {
  z-index: 999;
  display: none;
  position: absolute;
  top: -20px;
  left: auto;
  right: -310px;
  width: 280px;
  background: $color_main;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  animation: fadeIn .3s ease-in;

  &__list {
    max-height: 272px;
    overflow: auto;
    margin: 8px;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: $color_third;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color_second;
    }
  }

  &__item {
    border-bottom: 1px solid $border_color;
  }

  &__link {
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    font-weight: normal;
    padding: 10px 10px;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 25px;
    left: -6px;
    margin: 0 auto;
    width: 10px;
    height: 10px;
    background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
    border: 1px solid $border_color;
    border-bottom: none;
    border-right: none;
    transform: rotate(-45deg);
    box-shadow: 2px 2px 0 1px $color_main,
    -2px 0px 3px rgba(0, 0, 0, 0.25);
  }

  &_active {
    display: block;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
